import { UseTimeZone } from '../../../../common/hooks/useTimeZone'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'

export const DateOrderedCell = ({ val, locale }) => {
  const timeZone = UseTimeZone()

  return formatDateTime(val, FORMAT.DATE, locale, timeZone)
}
